
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    LAUNCHREPORT_ACTION,
    ALL_LAUNCHREPORT,
    ADD_LAUNCHREPORT,
    DELETE_LAUNCHREPORT,
    EDIT_LAUNCHREPORT
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * LAUNCH MONITOR REPORT Actions
 */

    export const allLaunchReport = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: LAUNCHREPORT_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqlaunchreport', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_LAUNCHREPORT, payload: alldata });
            });
        }        
    
    }

    export const addLaunchReport = (data, selfile) =>{
    
        var payload={
            "student":data.target.student.value,
            "date":data.target.seldate.value,
            "reportname":data.target.reportname.value,
            "fileupl":selfile,
        }
        return (dispatch) => { 
            dispatch({ type:LAUNCHREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/uploadtqlaunchreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allLaunchReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_LAUNCHREPORT});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }    


    export const deleteLaunchReport = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:LAUNCHREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqlaunchreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allLaunchReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_LAUNCHREPORT});                    
                }                
                
            });
        
        }
    }

    export const editLaunchReport = (data) => {
        const payload = {
            student: data.target.student,
            date: data.target.seldate,
            reportname: data.target.reportname,
            fileupl: data.target.fileupl,
            oldfiles: data.oldfiles,
            id: data.id 
        };
    
        return (dispatch) => {
            dispatch({ type: LAUNCHREPORT_ACTION });
            return axios.post(AppConfig.apiurl + '/api/edittqlaunchreport', payload, { headers: AuthHeader.header })
                .then(response => {
                    const resdata = response.data;
                    if (resdata.status === 1) {
                        allLaunchReport()(dispatch);
                        NotificationManager.success(resdata.message);
                        dispatch({ type: EDIT_LAUNCHREPORT, payload: resdata });
                    } else {
                        NotificationManager.error('Unsuccessful API call');
                    }
                })
                .catch(error => {
                    NotificationManager.error('Error: ' + error.message); 
                });
        }
    }

